import { render, staticRenderFns } from "./VideoDescription.vue?vue&type=template&id=5f0e54ef&scoped=true"
import script from "./VideoDescription.vue?vue&type=script&lang=js"
export * from "./VideoDescription.vue?vue&type=script&lang=js"
import style0 from "./VideoDescription.vue?vue&type=style&index=0&id=5f0e54ef&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0e54ef",
  null
  
)

export default component.exports